<template>
  <div id="mytasks" class="tab-cnt mytasklist">
    <div class="mytask-status">
      <h2 v-if="myTaskList.length">
        <span>{{totalTask}}</span>
        {{$t('pendingTasks')}}
      </h2>
      <div class="total-task" v-else>
        <span>0</span>
        {{$t('taskAvailable')}}
      </div>
      <!-- <div class="progress-task">
        <span style="width: 20%;"></span>
      </div>
      <div class="total-mytask" v-if="pendingTasks.length">
        <span>{{pendingTasks[0].number_of_task_accepted}} {{$t('task')}}</span>
        {{$t('completed')}}
      </div>-->
    </div>

    <ul>
      <li v-for="(task,index) in myTaskList" :key="index" @click="getTaskDetail(task)">
        <div class="item-icon">
          <img :src="require('../assets/images/task-note.svg')" alt />
        </div>
        <div class="task-info">
          <h2>{{task.title}}</h2>
          <p
            v-if="task.delivery_time"
          >{{$t('taskCompletionTime')}} : {{ task.delivery_time.slice(0, task.delivery_time.indexOf('T')) }}</p>
          <p>Rs. {{task.payment}} {{$t('perTask')}}</p>

          <div class="mytask-status" v-if="[0 ,1 , 2].includes(task.progress)">
            {{$t('status')}}:
            <span v-if="[0 ,1 , 2].includes(task.progress)">
              <span v-if="task.progress === 0">STARTED</span>
              <span v-if="task.progress === 1">PARTIALLY-COMPLETED</span>
              <span v-if="task.progress === 2">COMPLETED</span>
            </span>
          </div>
          <div class="mytask-status">
            {{$t('payment')}}:
            <span v-if="[3 , 4].includes(task.progress)">
              <span v-if="task.progress == 3">PAYMENT-INITIATED</span>
              <span v-if="task.progress == 4">DENIED</span>
            </span>
            <span v-else>NOT INITIATED</span>
          </div>
        </div>
      </li>
      <infinite-loading @infinite="getMyTask">
        <template slot="no-more">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    </ul>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>
<script>
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
import { mapGetters } from "vuex";
import types from "../store/types";
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";

Vue.use(InfiniteLoading);

export default {
  name: "MyTaskList",
  data() {
    return {
      loading: false,
      totalTask: 0,
      pageIndex: 0,
      myTaskList: []
    };
  },
  computed: {
    ...mapGetters(["pendingTasks"])
  },
  methods: {
    getTaskDetail(taskDetail) {
      if (taskDetail.extra.order_id) {
        this.$router.push(
          "/my-task-detail?myTaskIndex=" +
            taskDetail.Task_id +
            "&orderId=" +
            taskDetail.extra.order_id
        );
      } else {
        this.$router.push(
          "/my-task-detail?myTaskIndex=" + taskDetail.Task_id
        );
      }
    },
    getMyTask($state) {
      // this.loading = true;
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/orders/" + "?limit=" + this.pageIndex,
        "get"
      )
        .then(data => {
          // this.loading = false;
           if (data.data.length) {
            this.pageIndex += 1;
            this.myTaskList.push(...data.data);
            $state.loaded();
          } else {
            $state.complete();
          }
          this.totalTask = data.total_task;
        })
        .catch(err => {
          // this.loading = false;
          console.log(err);
        });
    }
  },
  mounted() {
    // if (SessionHelper.getCookie(X_AUTH_ID)) {
    //   this.getPendingTask();
    // }
  }
};
</script>
<style scoped>
.mytasklist li .task_detail {
  width: 100%;
  height: auto;
  border-radius: 8px;
  background: #ffffff;
  -webkit-box-shadow: 0 0px 5px 1px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0px 5px 1px rgba(0, 0, 0, 0.22);
  margin-bottom: 16px;
  padding: 16px 8px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
</style>